import { render, staticRenderFns } from "./AutoReplySetUpDetail.vue?vue&type=template&id=b2370874&"
import script from "./AutoReplySetUpDetail.vue?vue&type=script&lang=js&"
export * from "./AutoReplySetUpDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2370874')) {
      api.createRecord('b2370874', component.options)
    } else {
      api.reload('b2370874', component.options)
    }
    module.hot.accept("./AutoReplySetUpDetail.vue?vue&type=template&id=b2370874&", function () {
      api.rerender('b2370874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/AutoReplySetUp/AutoReplySetUpDetail.vue"
export default component.exports